/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateAvailableCurrencies200ResponseReissueOneOf
 */
export interface UpdateAvailableCurrencies200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseReissueOneOf
     */
    'cardType': UpdateAvailableCurrencies200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const UpdateAvailableCurrencies200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type UpdateAvailableCurrencies200ResponseReissueOneOfCardTypeEnum = typeof UpdateAvailableCurrencies200ResponseReissueOneOfCardTypeEnum[keyof typeof UpdateAvailableCurrencies200ResponseReissueOneOfCardTypeEnum];


